/**
 * @generated SignedSource<<d04df0491bd25ef75031c59ea931d66b>>
 * @relayHash c24967159bb4a4104f64a6cda2778024
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 5924a2a47de0360380a4172ab746685f7706bc2dedc58d97dc11874d199434c0

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JswExpandableProjectRefactoredQuery$variables = {
  cloudId: string;
  entityAri: string;
  noOfBoardsToFetch: number;
  ownerAri: string;
  projectKey: string;
};
export type JswExpandableProjectRefactoredQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"JswBoardsRefactored">;
};
export type JswExpandableProjectRefactoredQuery = {
  response: JswExpandableProjectRefactoredQuery$data;
  variables: JswExpandableProjectRefactoredQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "entityAri"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "noOfBoardsToFetch"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "ownerAri"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "projectKey"
},
v5 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v6 = {
  "kind": "Variable",
  "name": "entityAri",
  "variableName": "entityAri"
},
v7 = {
  "kind": "Variable",
  "name": "ownerAri",
  "variableName": "ownerAri"
},
v8 = {
  "kind": "ScalarField",
  "name": "id"
},
v9 = {
  "kind": "ScalarField",
  "name": "isFavourite"
},
v10 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v11 = {
  "kind": "ScalarField",
  "name": "boardId"
},
v12 = {
  "kind": "InlineFragment",
  "selections": [
    (v8/*: any*/)
  ],
  "type": "Node",
  "abstractKey": "__isNode"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "name": "JswExpandableProjectRefactoredQuery",
    "selections": [
      {
        "args": [
          (v5/*: any*/),
          (v6/*: any*/),
          {
            "kind": "Variable",
            "name": "noOfBoardsToFetch",
            "variableName": "noOfBoardsToFetch"
          },
          (v7/*: any*/),
          {
            "kind": "Variable",
            "name": "projectKey",
            "variableName": "projectKey"
          }
        ],
        "kind": "FragmentSpread",
        "name": "JswBoardsRefactored"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v4/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "JswExpandableProjectRefactoredQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": [
              (v5/*: any*/),
              {
                "kind": "Variable",
                "name": "key",
                "variableName": "projectKey"
              }
            ],
            "concreteType": "JiraProject",
            "kind": "LinkedField",
            "name": "jiraProjectByKey",
            "plural": false,
            "selections": [
              {
                "alias": "projectKey",
                "kind": "ScalarField",
                "name": "key"
              },
              {
                "kind": "ScalarField",
                "name": "projectId"
              },
              {
                "kind": "ScalarField",
                "name": "projectType"
              },
              (v8/*: any*/),
              (v9/*: any*/),
              {
                "args": [
                  {
                    "kind": "Variable",
                    "name": "first",
                    "variableName": "noOfBoardsToFetch"
                  }
                ],
                "concreteType": "JiraBoardConnection",
                "kind": "LinkedField",
                "name": "boards",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraBoardEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "JiraBoard",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v10/*: any*/),
                          (v8/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "name"
                          },
                          (v11/*: any*/),
                          {
                            "kind": "LinkedField",
                            "name": "defaultNavigationItem",
                            "plural": false,
                            "selections": [
                              (v10/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "url"
                                  }
                                ],
                                "type": "JiraNavigationItem",
                                "abstractKey": "__isJiraNavigationItem"
                              },
                              (v12/*: any*/)
                            ]
                          },
                          {
                            "concreteType": "JiraFavouriteValue",
                            "kind": "LinkedField",
                            "name": "favouriteValue",
                            "plural": false,
                            "selections": [
                              (v9/*: any*/),
                              (v8/*: any*/)
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "name": "mostRecentlyViewedBoard",
                "plural": false,
                "selections": [
                  (v10/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v11/*: any*/)
                    ],
                    "type": "JiraBoard"
                  },
                  (v12/*: any*/)
                ]
              },
              {
                "kind": "ScalarField",
                "name": "softwareBoardCount"
              }
            ]
          }
        ]
      },
      {
        "args": [
          (v6/*: any*/),
          (v7/*: any*/)
        ],
        "concreteType": "SettingsNavigationCustomisation",
        "kind": "LinkedField",
        "name": "settings_navigationCustomisation",
        "plural": false,
        "selections": [
          {
            "concreteType": "SettingsMenuItemConnection",
            "kind": "LinkedField",
            "name": "sidebar",
            "plural": false,
            "selections": [
              {
                "concreteType": "SettingsMenuItem",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "menuId"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "visible"
                  }
                ]
              }
            ]
          },
          (v8/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "id": "5924a2a47de0360380a4172ab746685f7706bc2dedc58d97dc11874d199434c0",
    "metadata": {},
    "name": "JswExpandableProjectRefactoredQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "b18b8bb5b35f58a943dfe5e8f70b1a87";

import { PreloadableQueryRegistry } from 'relay-runtime';
PreloadableQueryRegistry.set(node.params.id, node);

export default node;
